import { remove, get } from 'lodash';
import {composeReducers} from 'common/util/composeReducers';
import { PART11_WRITE_DOCUMENT, PART11_REMOVE_DOCUMENT, LOAD_ME_BINDER_PERMISSIONS } from 'part11/actions/documents';

export function writeDocument(state, action) {
    if (!action || action.type !== PART11_WRITE_DOCUMENT) {
        return state;
    }

    const document = action.payload;

    return {
        ...state,
        documents: {
            ...state.documents,
            [document.id]: document
        }
    };
}

export function removeDocument(state, action) {
    if (!action || action.type !== PART11_REMOVE_DOCUMENT) {
        return state;
    }

    const result = { ...state };

    const { documentId } = action.payload;
    const documents = get(result, 'files.documents');
    remove(documents, (document) => document.id === documentId);

    return result;
}

export function loadMeBinderPermissions(state, action) {
    if (!action || action.type !== LOAD_ME_BINDER_PERMISSIONS) {
        return state;
    }

    const userBinderPermissions = action.payload;

    return {
        ...state,
        me: {
            ...state.me,
            binderPermissions: userBinderPermissions,
        }
    };
}

export default composeReducers(
    writeDocument,
    removeDocument,
    loadMeBinderPermissions,
);
